export default __webpack_public_path__ + "static/media/TCKnife.6084aa40.png";